import { connect } from 'react-redux';
import Detail from './Detail';
import timeDepositActions from '../../../../store/actions/timeDeposit.action';

const mapStateToProps = state => ({
  timeDeposit: state.timeDeposit.timeDeposit,
  list: state.timeDeposit.list
});

const mapDispatchToProps = dispatch => {
  return {
    getTimeDeposit: id => {
      dispatch(timeDepositActions.getTimeDeposit(id));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Detail);
